module.exports = __webpack_public_path__ + "img/guide02.4a191262.jpg";